
const Services = () => {
  const services = [
    {
      icon: 'ri-map-2-line',
      title: 'Geländevermessungen',
      description: 'Hochpräzise Vermessungen von Gelände mit modernster Drohnen-Technologie für exakte topographische Daten und 3D-Modelle.',
      features: ['3D-Kartierung', 'Topographische Aufnahmen', 'Volumenberechnungen', 'CAD-kompatible Daten'],
      image: 'https://public.readdy.ai/ai/img_res/c10f2ff24600076a56ab031631fa87f7.jpg'
    },
    {
      icon: 'ri-search-eye-line',
      title: 'Such- und Rettungsaktionen',
      description: 'Spezialisierte Suchaktionen für Wildtiere und Rettungsaktionen für Personen mit Wärmebildkameras und GPS-Tracking.',
      features: ['Wärmebildtechnik', 'GPS-Ortung', '24/7 Einsatzbereitschaft', 'Schnelle Reaktionszeit'],
      image: 'https://readdy.ai/api/search-image?query=Search%20and%20rescue%20drone%20with%20thermal%20imaging%20camera%20flying%20over%20forest%20area%2C%20emergency%20response%20equipment%2C%20professional%20rescue%20operation%2C%20thermal%20vision%20technology%2C%20safety%20and%20security%20focus%2C%20clean%20technical%20background&width=600&height=400&seq=rescue-service&orientation=landscape'
    },
    {
      icon: 'ri-sun-line',
      title: 'Photovoltaik-Inspektionen',
      description: 'Professionelle Inspektionsüberflüge für Solaranlagen zur Erkennung von Defekten und Optimierung der Energieausbeute.',
      features: ['Thermografie-Analyse', 'Defekterkennung', 'Effizienzprüfung', 'Wartungsplanung'],
      image: 'https://readdy.ai/api/search-image?query=Drone%20inspecting%20solar%20panel%20installation%20on%20rooftop%2C%20photovoltaic%20system%20inspection%2C%20thermal%20imaging%20of%20solar%20panels%2C%20renewable%20energy%20technology%2C%20professional%20inspection%20equipment%2C%20clean%20industrial%20background&width=600&height=400&seq=solar-inspection&orientation=landscape'
    },
    {
      icon: 'ri-building-2-line',
      title: 'Gemeinden & Städte',
      description: 'Umfassende Dienstleistungen für kommunale Einrichtungen zur Stadtplanung, Infrastruktur-Überwachung und Dokumentation.',
      features: ['Stadtplanung', 'Infrastruktur-Monitoring', 'Dokumentation', 'Bürgerprojekte'],
      image: 'https://readdy.ai/api/search-image?query=Aerial%20view%20of%20modern%20city%20infrastructure%20with%20drone%20technology%2C%20urban%20planning%20and%20development%2C%20municipal%20services%2C%20smart%20city%20concept%2C%20professional%20aerial%20photography%20of%20buildings%20and%20streets%2C%20clean%20urban%20background&width=600&height=400&seq=municipal-service&orientation=landscape'
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4">
            Unsere <strong>Dienstleistungen</strong>
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Mit modernster Drohnen-Technologie bieten wir präzise und zuverlässige Lösungen 
            für verschiedenste Anwendungsbereiche in ganz Süddeutschland.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="aspect-video">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-8">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4">
                    <i className={`${service.icon} text-2xl text-teal-600`}></i>
                  </div>
                  <h4 className="text-2xl font-bold text-gray-900">{service.title}</h4>
                </div>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {service.description}
                </p>
                <div className="grid grid-cols-2 gap-3">
                  {service.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className="flex items-center">
                      <i className="ri-check-line text-teal-600 mr-2"></i>
                      <span className="text-sm text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
